import React from 'react';
import { formatNumberWithTwoDecimals } from './currencyUtils';
import { formatDate, formatDatePickerDefaultValue, isValidDate } from '@Shared/Utils/dateHelpers';

export function getTableColumns(columns) {
    let columnsDefinition = Object.getOwnPropertyNames(columns);
    let searchTableColumns = [];
    columnsDefinition.forEach((item, index) => {
        let column = {
            index: index,
            name: item,
            title: columns[item].title ?? "",
            field: columns[item].field ?? "",
            format: columns[item].format ?? 0,
            summarize: columns[item].summarize ?? false,
            summarizeCustom: columns[item].summarizeCustom ?? false,
            show: columns[item].show ?? true,
            Header: columns[item].title,
            description: columns[item].description ?? columns[item].tooltip ?? columns[item].title,
            accessor: item,
            sortable: columns[item]?.sortable,
            filterable: columns[item]?.filterable ?? true,
            resizable: true,
            Footer: columnProps => React.createElement(
                'span',
                null,
                React.createElement(
                    'b',
                    null,
                    columns[item].summarizeCustom
                        ? renderCustomSummary(columnProps.data, columns[item].summarizeCustom)
                        : "",
                    columnProps.data.length > 0 && columns[item].summarize
                        ? formatTableColumn(
                            sumPropertyValue(columnProps.data.map(v => v._original || v), columns[item].field || item),
                            columns[item].signo
                        )
                        : ""
                )
            ),
        };

        if (columns[item].displayFormat === 'date' || columns[item].displayFormat === 4) {
            console.log('Adding date column for', item);
            column.id = item;
            const fieldToUse = columns[item].field || item;
            column.accessor = row => row[fieldToUse]
            column.Cell = ({ value }) => {
                if (!value) return '';
                if (columns[item].dateOnly) {
                    return formatDatePickerDefaultValue(value);
                }
                const date = new Date(value);
                return isValidDate(date) ? formatDate(date, 'dd/MM/yyyy') : '';
            }
            column.sortMethod = (a, b, desc) => {
                const dateA = new Date(a);
                const dateB = new Date(b);
                if (!isValidDate(dateA) || !isValidDate(dateB)) return 0;

                const result = dateA.getTime() - dateB.getTime();
                return desc ? -Math.sign(result) : Math.sign(result);
            };

        }
        else if (columns[item].displayFormat === 'money' || columns[item].displayFormat === 5) {
            column.id = item;
            const fieldToUse = columns[item].field || item;
            column.accessor = row => row[fieldToUse];

            column.Cell = ({ value }) =>
                React.createElement(
                    'div',
                    { style: { marginLeft: columns[item].alignRight ? "auto" : undefined } },
                    value != null && !isNaN(value) ? formatMoney(value) : "-"
                );
        }
        else column.Cell = ({ value }) =>
            value


        if (columns[item].width != null)
            column.width = columns[item].width;

        searchTableColumns.push(column);
    });

    return searchTableColumns;
}

function formatMoney(value, currency = "$") {
    return currency + ' ' + parseFloat(value).toLocaleString("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

function renderCustomSummary(rows, summarizeCustom) {
    const firstRow = rows?.[0];
    if (!firstRow) return '';

    let parentOriginal = firstRow.__parentOriginal;

    if (!parentOriginal && firstRow.original?.__parentOriginal) {
        parentOriginal = firstRow.original.__parentOriginal;
    }

    if (!parentOriginal && firstRow._original?.__parentOriginal) {
        parentOriginal = firstRow._original.__parentOriginal;
    }

    return formatCustomLabel(parentOriginal, summarizeCustom, rows);
}

function formatCustomLabel(parentOriginal, summarizeCustom, rows) {
    if (!parentOriginal || !summarizeCustom) return '';

    if (typeof summarizeCustom === 'function') {
        const val = summarizeCustom({ parentOriginal, rows });
        return isFiniteNumber(val) ? formatMoney(val) : '';
    }
    const raw = parentOriginal[summarizeCustom];
    const num = toNumber(raw);
    return num && isFiniteNumber(num) ? formatMoney(num) : '';
}

function toNumber(v) {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    if (typeof v === 'string')
        return parseFloat(v.replace('$', '').replace(/\./g, '').replace(',', '.').trim());
    return Number(v) || 0;
}

function isFiniteNumber(n) {
    return typeof n === 'number' && isFinite(n);
}

function sumPropertyValue(items, prop) {
    let total = items.reduce((sum, item) => {
        if (!item) return sum;

        let dataItem = item.original || item._original || item;

        if (!dataItem) return sum;

        let value = dataItem[prop];
        if (typeof value === 'string') {
            value = value.replace('$', '').replace(/\./g, '').replace(',', '.').trim();
        }

        value = parseFloat(value);

        return sum + (isNaN(value) ? 0 : value);
    }, 0);

    return total;
}

function formatTableColumn(value, signo = '') {
    let label = `${signo} ${formatNumberWithTwoDecimals(value)}`;
    return label.trim();
}
